<template>
  <v-form>
    <v-container class="my-6">
      <v-row no-gutters>
        <v-col>
          <v-text-field
            dense
            outlined
            v-model="formData.transactionCode"
            label="Enter Your Mpesa Confirmation Code"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "ConfirmPayment",
  props: {
    payload: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      formData: {
        transactionCode: "",
        sourceDocumentNo: "",
      },
    };
  },

  mounted() {
    Event.$on("confirm-payment", () => {
      this.confirmPayment();
    });
  },

  methods: {
    confirmPayment() {
        console.log('Confirm Payment', this.formData);
        this.$store.dispatch("Checkout/confirmPayment", {...this.formData});
    }
  },
  watch: {
    payload: {
      handler: function () {
        this.formData.sourceDocumentNo = this.payload.sourceDocumentNo;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
